import { render, staticRenderFns } from "./Haku.vue?vue&type=template&id=fff10132"
import script from "./Haku.vue?vue&type=script&lang=js"
export * from "./Haku.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports